(() => {
  const existing = window.YamDeferredSlideshowImages;
  if (existing) {
    existing.init(document);
    return;
  }

  const loadPicture = (picture) => {
    picture.querySelectorAll('[data-srcset]').forEach((element) => {
      element.setAttribute('srcset', element.dataset.srcset);
      element.removeAttribute('data-srcset');
    });

    const image = picture.querySelector('img[data-src]');
    if (image) {
      image.setAttribute('src', image.dataset.src);
      image.removeAttribute('data-src');
    }

    picture.classList.remove('slideshow__picture--deferred');
    picture.dataset.deferredImageLoaded = 'true';
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              loadPicture(entry.target);
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 100px', threshold: 0.01 }
        )
      : null;

  const init = (root) => {
    root.querySelectorAll('.slideshow__picture--deferred:not([data-deferred-image-ready])').forEach((picture) => {
      picture.dataset.deferredImageReady = 'true';
      if (observer) {
        observer.observe(picture);
      } else {
        loadPicture(picture);
      }
    });
  };

  window.YamDeferredSlideshowImages = { init, loadPicture };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
